import { Plugin } from '@ckeditor/ckeditor5-core';
import ImageFullBig from '../theme/icons/inspector.svg';
import ImageFullCancel from '../theme/icons/inspector.svg';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import '../theme/css/style.css';

export default class Inspect extends Plugin {
	init() {
		const editor = this.editor;

		editor.ui.componentFactory.add('inspect', (locale) => {
			const view = new ButtonView(locale);
			let state = 0; //si 0 position normale
			view.set({
				label: 'Attach Inspector',
				icon: ImageFullBig,
				tooltip: true,
			});

			// Callback executed once the image is clicked.
			view.on('execute', () => {
				if (state == 1) {
					editor.config.get('inspect').callback(false);

					view.set({
						label: 'Attach Inspector',
						icon: ImageFullBig,
						tooltip: true,
					});
					state = 0;
				} else {
					editor.config.get('inspect').callback(true);
					view.set({
						label: 'Detach Inspector',
						icon: ImageFullCancel,
						tooltip: true,
					});
					state = 1;
				}
			});

			return view;
		});
	}
}
